import React from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import Link from './link.js'

const UnstyledButton = ({
  className,
  children,
  url,
  path,
  target,
  to,
  ...rest
}) => {
  const props = {
    className,
    tag: url ? 'a' : 'div',
    to: path || to,
    href: url || null,
    target,
    ...rest
  }

  if (to || path) {
    return <Link {...props}>{children}</Link>
  }

  else if (url) {
    const aProps = {
      href: url,
      className,
      target: '_blank'
    }

    return <a {...aProps}>{children}</a>
  }

  else {
    return <div {...props}>{children}</div>
  }
}

const Button = styled(UnstyledButton)`
  appearance: none;
  outline: none;
  display: inline-block;
  cursor: pointer;
  font-family: inherit;
  font-size: ${theme.font.size.p};
  padding: .3em .5em;
  color: ${props => {
    return 'white'
  }};
  background-color: none;
  background: ${props => {
    return theme.color.grey.darkest
  }};

  &:hover {
    opacity: .7;
  }
`

export default Button